import {Link, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import {getMyFilteredTickets} from "../api/services.ts";
import GoBackHeader from "../components/GoBackHeader.tsx";
import TicketSlide from "../components/TicketsSlide.tsx";
import Routes from "../utils/routes.ts";

const EventsPurchasedTickets = () => {
    const [filteredTickets, setFilteredTickets] = useState();
    const { state } = useLocation();
    const tickets = state?.tickets;

    useEffect(() => {
        const vouchers = getMyFilteredTickets(tickets)
        setFilteredTickets(vouchers);
    },[])

    return (
        <div
            style={{
                backgroundImage: `url('/pattern-white.svg')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
            className="min-h-screen py-4 px-2 flex flex-col justify-between"
        >
            {/* Header */}
            <div>
                <GoBackHeader/>
                <div className="items-start h-full overflow-y-auto z-10 px-2  mt-4 w-full">
                    {filteredTickets ? (<TicketSlide tickets={filteredTickets}/>) : (
                        <div className="flex flex-col gap-4">
                            <p>Aucun ticket n'est disponible pour le moment</p>
                        </div>
                    )}
                </div>
            </div>
            <div className="flex flex-col justify-center items-center mt-2 w-full">
                <Link
                    className="bg-white w-full self-center border border-third  flex items-center justify-center text-third font-semibold py-4 px-4 rounded-full w-3/4 max-w-xs mt-2"
                    to={`/${Routes["Evenements de l'utilisateur"]}`}>
                    Voir tout mes tickets
                </Link>
            </div>
        </div>
    );
};

export default EventsPurchasedTickets;
